/**
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @module Algolia
 *
 * @author Naseef O
 *
 */

import { InsightsMethodMap } from "search-insights";

export const hitsPerPage = 36;

export const algoliaQueryParams: { [key: string]: string } = {
  BRANDS: "b",
  FEATURES: "f",
  SHAPE: "s",
  FRAME_TYPE: "ft",
  FIT: "ff",
  COLOR: "c",
  MATERIAL: "fm",
  PRICE_MIN: "pmin",
  PRICE_MAX: "pmax",
  PAGE: "page",
  SORT: "sort",
  CATEGORY: "cat",
};

export const algoliaResults: { [key: string]: string } = {
  MAIN: "main",
  ALL_FACETS: "allFacets",
};

export enum ListType {
  City = "city",
  Area = "area",
}

export enum SanityFilterTypes {
  category = "categoryFilter",
  brands = "brands",
}

export const algoliaEventParam: { [key: string]: keyof InsightsMethodMap } = {
  ADDED_TO_CART: "addedToCartObjectIDsAfterSearch",
  ADDED_TO_CART_NO_QUERY: "addedToCartObjectIDs",
  INIT: "init",
  PRODUCT_CLICK: "clickedObjectIDsAfterSearch",
  CLICKED_OBJECTIDS: "clickedObjectIDs",
  PRODUCT_VIEW: "viewedObjectIDs",
  CONVERTED_AFTER_SEARCH: "convertedObjectIDsAfterSearch",
  CONVERTED: "convertedObjectIDs",
  PURCHASED_AFTER_SEARCH: "purchasedObjectIDsAfterSearch",
  PURCHASED: "purchasedObjectIDs",
  VIEWED_FILTERS: "viewedFilters",
  CLICKED_FILTERS: "clickedFilters",
  CONVERTED_FILTERS: "convertedFilters",
};

export const eventParam: { [key: string]: string } = {
  ADDED_TO_CART: "Add to cart",
  PRODUCT_CLICK: "Product click",
  PRODUCT_VIEW: "Product viewed",
  WISHLIST_ADD: "Add to wishlist",
  PURCHASE: "Purchase",
  FILTER_CLICK: "Filter clicked",
  FILTER_VIEW: "Filter viewed",
  FILTER_CONVERT: "Filter converted",
};

export const algoliaRecommendationParam: { [key: string]: string } = {
  TENDING_ITEMS: "trending-items",
};

export const productListingPageKey: { [key: string]: string } = {
  categoryListing: "c",
  brandListing: "b",
  collectionListing: "cl",
};

export const productListingPageTypes: { [key: string]: string } = {
  c: "CLP",
  b: "BLP",
  cl: "PLP",
};

export const algoliaGuestToken: { [key: string]: string } = {
  ALGOLIA_GUEST_TOKEN: "algolia_guest_token",
};
